import React from 'react';
import Breadcrumb from "../../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import InfoAlert from '../../../../../../CommonComponents/Info/Alert/Alert';
import BreadcrumbComponent from '../../../../../../CommonComponents/Breadcrumb/Breadcrumb';
import { ContentMessage, Types } from '../../../../../../CommonComponents/ContentMessages';
import { RecommendAnExchangeHeading, RecommendAnExchangesHeading, TradeCutOffInfo } from '../../styles';
import Summary from '../summary';
import ScheduleType from '../scheduleType';
import moment from 'moment';
import {
    DateTimeFormat,
  } from '../../constants';

const AccountSummary = (props) => {
    const tradeCutoffDateAndTime = props.tradeCutoffDateAndTime && (props.tradeCutoffDateAndTime.tradeCutoffDateAndTime ? 'Trade cutoff for ' +  moment(props.tradeCutoffDateAndTime.tradeCutoffDateAndTime).format(DateTimeFormat) : props.tradeCutoffDateAndTime.message)
    return (
        <div data-test="accountSummary">
            <BreadcrumbComponent breadcrumbRoutes={props.breadcrumbRoutes} />
            <RecommendAnExchangesHeading role="heading" aria-level="1">{props.title}</RecommendAnExchangesHeading>
            <Summary
                accountName={props.accountName}
                accountId={props.accountId}
                currentBalance={props.currentBalance}
                availableBalance={props.availableBalance}
            />
            {props.isNew && <ScheduleType data-test="scheduleTypeBlock" activeKey={props.scheduleType}  handleChange={(type) => props.handleChangeScheduleType(type)} />}
            <InfoAlert
                type="Note: "
                heading={<ContentMessage html={true} page='Recommend an Exchange' 
                    type={Types.PAGE_NOTICES} property='field_notice_content' 
                    defaultMessage="All investment exchange recommendations are subject to approval. Learn more about <a href=''>exchange approval policies</a> here." 
                    messageId="heading"
                />}
                body={<ContentMessage html={true} page='Recommend an Exchange' 
                    type={Types.PAGE_NOTICES} property='field_show_more_content' 
                    defaultMessage="Exchange recommendations submitted after the day’s trade cutoff may be processed the following business day. Recommendations that involve large dollar amounts may be processed over multiple business days." 
                    messageId="body"
                />}
                footer={<TradeCutOffInfo> {tradeCutoffDateAndTime}</TradeCutOffInfo>}
            />            
        </div>
    );
};

export default AccountSummary;